import { notEmpty } from "@product/scmp-sdk";
import { useAtomValue } from "jotai";
import first from "lodash/first";
import type { FunctionComponent } from "react";
import { useRef } from "react";
import { SwitchTransition } from "react-transition-group";

import { gdprAtom } from "~/components/tracking/gdpr/hooks";
import { Fade } from "~/components/transition/fade";

import { useHomeAccountActivation } from "./account-activation/hooks";
import { HomeNewsTickerContainer } from "./styles";

export const HomeNewsTicker: FunctionComponent = () => {
  const gdprStatus = useAtomValue(gdprAtom);
  const homeAccountActivation = useHomeAccountActivation();

  const items = [{ key: "homeAccountActivation", value: homeAccountActivation }].filter(element =>
    notEmpty(element.value),
  );
  const firstItem = first(items);
  const shouldShow = items.length > 0;

  const reference = useRef<HTMLDivElement>(null);

  if (!gdprStatus.isAccepted) return null;
  return (
    <Fade inProperty={shouldShow} nodeRef={reference}>
      <HomeNewsTickerContainer ref={reference}>
        <SwitchTransition mode="out-in">
          <Fade inProperty={true} key={firstItem?.key}>
            {firstItem?.value}
          </Fade>
        </SwitchTransition>
      </HomeNewsTickerContainer>
    </Fade>
  );
};
HomeNewsTicker.displayName = "HomeNewsTicker";
